export const CONTINENTS = ["All","Africa","Asia","Europe","N. America","S. America","Oceania","Antarctica"];

export const GRADE_ORDER = ["I","II","III","IV","V","VI","VII"];
export const gradeRank = (g) => g == null ? 99 : GRADE_ORDER.indexOf(g) + 1;

export const CATEGORY_META = {
  flat:      { label: "Flat",      color: "#6BA368", desc: "Under 200m" },
  hill:      { label: "Hill",      color: "#D4A843", desc: "200 – 2,000m" },
  mountain:  { label: "Mountain",  color: "#C07040", desc: "2,000 – 5,000m" },
  glaciated: { label: "Glaciated", color: "#5B8FA8", desc: "5,000 – 6,500m" },
  extreme:   { label: "Extreme",   color: "#8B3A62", desc: "Above 6,500m" },
};

export const SEVEN_SUMMITS = [
  { peak: "Mount Everest",      elev: "8,849m", continent: "Asia",          country: "Nepal / China",   note: "Highest point on Earth",          code: "NP" },
  { peak: "Aconcagua",          elev: "6,961m", continent: "South America", country: "Argentina",        note: "Highest outside Asia",            code: "AR" },
  { peak: "Denali",             elev: "6,190m", continent: "North America", country: "United States",    note: "Highest vertical rise",           code: "US" },
  { peak: "Kilimanjaro",        elev: "5,895m", continent: "Africa",        country: "Tanzania",         note: "Tallest free-standing mountain",  code: "TZ" },
  { peak: "Mount Elbrus",       elev: "5,642m", continent: "Europe",        country: "Russia",           note: "Highest in Europe",               code: "RU" },
  { peak: "Carstensz Pyramid",  elev: "4,884m", continent: "Oceania",       country: "Indonesia",        note: "Highest island peak",             code: "ID" },
  { peak: "Vinson Massif",      elev: "4,892m", continent: "Antarctica",    country: "Antarctica",       note: "Most remote summit",              code: "AQ" },
];

/** Continent zoom targets: { x, y, k } for projection centering */
export const CONT_VIEWS = {
  "All":        { x: 480, y: 250, k: 0.85 },
  "Africa":     { x: 510, y: 275, k: 1.6 },
  "Asia":       { x: 795, y: 185, k: 1.85 },
  "Europe":     { x: 510, y: 75, k: 3 },
  "N. America": { x: 165, y: 145, k: 1.75 },
  "S. America": { x: 285, y: 360, k: 1.75 },
  "Oceania":    { x: 990, y: 370, k: 2.5 },
  "Antarctica": { x: 480, y: 380, k: 0.9 },
};
